import React from 'react';
import { useSelector } from 'react-redux';

const Allergens = () => {
  const locale = useSelector(state => state.intl.locale);
  const path = locale === 'pl' ? 'allergens_pl.pdf' : 'allergens_en.pdf';
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.href = `/${path}`;
    }
  }, []);

  return null;
};
export default Allergens;
